import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {CoinsPackModal, ThemeContext} from '../../components/common';
import {landingShowed} from '../../actions/game';
import {updateUserCoins} from '../../actions/user';

const GiftContainer = (props) => {
  const {onLandingShowed, gameId, onUpdateUserCoins} = props;

  useEffect(() => {
    if (window.innerWidth < 700) {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('overflow', 'hidden');
      document.documentElement.classList.add('join-in-progress');
    }

    return () => {
      if (window.innerWidth < 700) {
        document.documentElement.style.setProperty('overflow', 'scroll');
        document.documentElement.classList.remove('join-in-progress');
      }
    };
  });

  const skipAndPlay = () => {
    onLandingShowed(gameId);
  };

  const [isCoinPacksModalOpen, toggleModal] = useState(false);

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const paymentPacks = Object.keys(theme.paymentPacks).map(key => theme.paymentPacks[key]);

        return (
          <div className="gift-landing__wrapper">
            <div className="gift-landing">
              <div className="gift-landing__main">
                <h1 className="gift-landing__heading">Gift a Player,<br/>Earn a Reward</h1>
                <div className="gift-landing__details">
                  <div>Redeem your coins in the Treasure Chest...</div>
                  <div>click on the link & see what Treasures await you!</div>
                  <ul className="gift-landing__list">
                    <li className="gift-landing__list-item">
                      <span>Buy & send gift Yak Silver to other players</span>
                    </li>
                    <li className="gift-landing__list-item">
                      <span>Earn 1/4 Yak Silver & the player earns 1/4</span>
                    </li>
                    <li className="gift-landing__list-item">
                      <span>4 Yak Silver = 1 Yak Gold</span>
                    </li>
                  </ul>
                </div>
                <button className="gift-landing__button" onClick={() => {toggleModal(true);}} type="button">BUY YAK SILVER</button>
                <button className="gift-landing__button gift-landing__button_secondary" onClick={skipAndPlay} type="button">SKIP AND PLAY</button>
              </div>
            </div>
            <div className="gift-landing__bubble gift-landing__avatar-1"/>
            <div className="gift-landing__bubble gift-landing__avatar-2"/>
            <div className="gift-landing__bubble gift-landing__avatar-3"/>
            <div className="gift-landing__bubble gift-landing__avatar-4"/>
            <div className="gift-landing__bubble gift-landing__bubble-orange gift-landing__bubble-orange-1"/>
            <div className="gift-landing__bubble gift-landing__bubble-orange gift-landing__bubble-orange-2"/>
            <div className="gift-landing__bubble gift-landing__bubble-orange gift-landing__bubble-orange-3">
              <i className="icon icon-video"/>
            </div>
            <div className="gift-landing__bubble gift-landing__bubble-blue gift-landing__bubble-blue-1"/>
            <div className="gift-landing__bubble gift-landing__bubble-blue gift-landing__bubble-blue-2"/>
            <div className="gift-landing__coins"/>
            <div className="gift-landing__silver"/>
            <CoinsPackModal
              isModalOpened={isCoinPacksModalOpen}
              onModalClose={() => {toggleModal(false);}}
              paymentPacks={paymentPacks}
              updateUserCoins={onUpdateUserCoins}
            />
          </div>
        );
      }}
    </ThemeContext.Consumer>
  );
};

GiftContainer.propTypes = {
  onLandingShowed: PropTypes.func.isRequired,
  gameId: PropTypes.string.isRequired,
  onUpdateUserCoins: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    onLandingShowed: gameId => landingShowed(gameId),
    onUpdateUserCoins: updateUserCoins,
  },
  dispatch
);

const mapStateToProps = (state) => {
  const {game: {currentGame: {id: gameId}}} = state;

  return {
    gameId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftContainer);
